
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, Trash2 } from "lucide-react";

interface Airline {
  id: string;
  name_ar: string;
  name_en: string;
  code: string;
  created_at: string;
}

interface AirlineCardProps {
  airline: Airline;
  onEdit: () => void;
  onDelete: () => void;
}

export const AirlineCard = ({ airline, onEdit, onDelete }: AirlineCardProps) => {
  return (
    <Card className="flex flex-col justify-between">
      <CardHeader>
        <div className="flex justify-between items-start">
            <div>
                <CardTitle className="leading-relaxed mb-1">{airline.name_ar}</CardTitle>
                <CardDescription className="text-left" dir="ltr">{airline.name_en}</CardDescription>
            </div>
            <Badge variant="outline">{airline.code}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          تاريخ الإنشاء: {new Date(airline.created_at).toLocaleDateString('ar-SA')}
        </p>
      </CardContent>
      <CardFooter>
        <div className="flex gap-2 justify-end w-full">
          <Button
            variant="ghost"
            size="sm"
            onClick={onEdit}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            className="text-red-600 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};
